









































import { mdiHeadset, mdiAccountMultiple, mdiPhone } from "@mdi/js";
import { Component, Mixins } from "vue-property-decorator";
import LanguageChanger from "@/components/utility/LanguageChanger.vue";
import IconItem from "@/components/ui/IconItem.vue";
import { LinkMixin } from "@/mixins/LinkMixin";

@Component({
  components: { LanguageChanger, IconItem },
})
export default class AppHeader extends Mixins(LinkMixin) {
  mdiHeadset = mdiHeadset;
  mdiAccountMultiple = mdiAccountMultiple;
  mdiPhone = mdiPhone;

  get logoMaxWidth() {
    switch (this.$vuetify.breakpoint.name) {
      case "sm":
      case "md":
      case "lg":
      case "xl":
        return "250px";
      case "xs":
      default:
        return "180px";
    }
  }
}
